import { defineComponent as _defineComponent } from 'vue'
import HomeSectionTitles from './HomeSectionTitles.vue';
  import AppButton from './AppButton.vue';
  import AppButtonOutlined from './AppButtonOutlined.vue';
  import IconCheck from '@/icons/icon-check.vue';
  import { useGetProduct } from '../composables/useGetProduct';
  import { onMounted, ref, computed } from 'vue';
  import type { SellProductModel } from '../stores/types';
  import type { Ref } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'HomePricing',
  setup(__props, { expose: __expose }) {
  __expose();

  const product: Ref<SellProductModel> | Ref<Record<string, never>> = ref({});

  onMounted(() => getProduct());

  const priceTrialFormated = computed(() => (product.value?.trial_price ? (product.value?.trial_price / 100).toFixed(2) : null));

  const priceSubscriptionFormated = computed(() =>
    product.value?.subscription_price ? (product.value?.subscription_price / 100).toFixed(2) : null
  );

  const getProduct = async () => {
    const productResponse: SellProductModel = await useGetProduct();
    product.value = productResponse;
  };

const __returned__ = { product, priceTrialFormated, priceSubscriptionFormated, getProduct, HomeSectionTitles, AppButton, AppButtonOutlined, IconCheck, get useGetProduct() { return useGetProduct }, onMounted, ref, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})